import { h } from "preact";
import { useState } from "preact/hooks";
import { useConsumers } from "./useConsumers";
import { ConsumersSearch } from "./ConsumersSearch";
import { ConsumersTable } from "./ConsumersTable";
import { NewConsumerModal } from "./AddConsumerModal.jsx";

const ConsumersPage = () => {
    const { consumers, loading, error, fetchConsumers, pagination } = useConsumers();
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");
    const [modalVisible, setModalVisible] = useState(false);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);

        clearTimeout(window.searchTimeout);
        window.searchTimeout = setTimeout(() => {
            fetchConsumers({
                current: 1,
                username: value,
                status: statusFilter
            });
        }, 500);
    };

    const handleStatusFilterChange = (value) => {
        setStatusFilter(value);
        fetchConsumers({
            current: 1,
            username: searchText,
            status: value
        });
    };

    const handlePrevPage = () => {
        if (pagination.hasPrev) {
            fetchConsumers({
                current: pagination.current - 1,
                username: searchText,
                status: statusFilter
            });
        }
    };

    const handleNextPage = () => {
        if (pagination.hasNext) {
            fetchConsumers({
                current: pagination.current + 1,
                username: searchText,
                status: statusFilter
            });
        }
    };

    const handleNewConsumer = () => {
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
    };

    const handleConsumerCreated = (newConsumer) => {
        // Refresh the consumers list after successful creation
        fetchConsumers();
    };
    return (
        <div className="consumers-page" style={{ minHeight: "100vh" }}>
            <ConsumersSearch
                searchText={searchText}
                onSearchChange={handleSearch}
                onRefresh={() => fetchConsumers({ username: searchText, status: statusFilter })}
                onNewConsumer={handleNewConsumer}
                loading={loading}
                statusFilter={statusFilter}
                onStatusFilterChange={handleStatusFilterChange}
            />

            {error && (
                <div style={{
                    margin: "0 24px 16px",
                    padding: "8px 16px",
                    color: "#f5222d",
                    background: "#fff1f0",
                    border: "1px solid #ffccc7",
                    borderRadius: "4px"
                }}>
                    {error}
                </div>
            )}

            <div style={{ padding: "0 24px" }}>
                <ConsumersTable
                    consumers={consumers}
                    loading={loading}
                    pagination={pagination}
                    onPrevPage={handlePrevPage}
                    onNextPage={handleNextPage}
                />
            </div>

            <NewConsumerModal
                visible={modalVisible}
                onClose={handleModalClose}
                onSuccess={handleConsumerCreated}
            />
        </div>
    );
};

export default ConsumersPage;